export const API_ENDPOINT = 'https://62576dd58489dda6509b3ce3.mockapi.io'
